import { useCallback, useState } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import { Error } from "../../../../Utils/Errors";
import { useApi } from "../../../../Utils/useApi";
import { postContactResultPath } from "../../../Constants/ApiRequestPaths";
import CreateContactResultRequest, { CreateContactResultRequestPayload } from "../Types/CreateContactResultRequest";
import UpdateContactResultResponse from "../Types/CreateOrUpdateContactResultResponse";

/**
 * A typed hook for post contact result operations.
 */
const UsePostContactResult: TriggeredHook<UpdateContactResultResponse, CreateContactResultRequest> = () => {
  const [requestPayload, setRequestPayload] = useState<CreateContactResultRequest | null>(null);

  const { response, error, isLoading } = useApi<UpdateContactResultResponse, CreateContactResultRequestPayload>({
    method: "post",
    url: postContactResultPath(requestPayload?.contactId ?? ""),
    data: requestPayload?.payload,
    valid: !!requestPayload,
    error: Error.PostLeadResult
  });

  const execute = useCallback((request: CreateContactResultRequest) => {
    setRequestPayload(request);
  }, []);

  return {
    execute,
    result: response ? response : null,
    error: error ? true : false,
    isLoading: isLoading
  };
};

export default UsePostContactResult;
